import React from 'react'
import PropTypes from 'prop-types'
import Label from './Label'
import useInput from '../../hooks/useInput'
import { AdOrderContext } from '../../contexts/AdOrder'

export default function SelectAllCities ({ cities }) {
  const { getValue, setValue, addValue, removeValue, contains } = useInput()

  const input = React.createRef()

  const checked = getValue('cities')?.length === cities.length

  const handleOnChange = function () {
    if (checked) {
      setValue('cities', [])
    } else {
      setValue('cities', cities)
    }
  }

  return (
    <div className={'checkbox'} >
      <Label>
        <input type={'checkbox'}
               checked={checked}
               ref={input}
               onChange={handleOnChange}
        />
        <span>
          Vælg alle byer
        </span>
      </Label>
    </div>
  )
}